module.exports = __webpack_public_path__ + "img/planet.7c3407f9.svg";